import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _get from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import PointLocator from '../algorithm/PointLocator';
import Location from '../geom/Location';
import LineString from '../geom/LineString';
import HashMap from '../../../../java/util/HashMap';
import Geometry from '../geom/Geometry';
import hasInterface from '../../../../hasInterface';
import Position from './Position';
import Coordinate from '../geom/Coordinate';
import Point from '../geom/Point';
import Polygon from '../geom/Polygon';
import MultiPoint from '../geom/MultiPoint';
import SimpleMCSweepLineIntersector from './index/SimpleMCSweepLineIntersector';
import LinearRing from '../geom/LinearRing';
import BoundaryNodeRule from '../algorithm/BoundaryNodeRule';
import Orientation from '../algorithm/Orientation';
import SegmentIntersector from './index/SegmentIntersector';
import MultiPolygon from '../geom/MultiPolygon';
import Label from './Label';
import GeometryCollection from '../geom/GeometryCollection';
import UnsupportedOperationException from '../../../../java/lang/UnsupportedOperationException';
import CoordinateArrays from '../geom/CoordinateArrays';
import Polygonal from '../geom/Polygonal';
import IndexedPointInAreaLocator from '../algorithm/locate/IndexedPointInAreaLocator';
import Assert from '../util/Assert';
import Edge from './Edge';
import MultiLineString from '../geom/MultiLineString';
import PlanarGraph from './PlanarGraph';
var GeometryGraph = /*#__PURE__*/function (_PlanarGraph) {
  _inherits(GeometryGraph, _PlanarGraph);
  function GeometryGraph() {
    var _this;
    _classCallCheck(this, GeometryGraph);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(GeometryGraph).call(this));
    GeometryGraph.constructor_.apply(_assertThisInitialized(_assertThisInitialized(_this)), arguments);
    return _this;
  }
  _createClass(GeometryGraph, [{
    key: "insertBoundaryPoint",
    value: function insertBoundaryPoint(argIndex, coord) {
      var n = this._nodes.addNode(coord);
      var lbl = n.getLabel();
      var boundaryCount = 1;
      var loc = Location.NONE;
      loc = lbl.getLocation(argIndex, Position.ON);
      if (loc === Location.BOUNDARY) boundaryCount++;
      var newLoc = GeometryGraph.determineBoundary(this._boundaryNodeRule, boundaryCount);
      lbl.setLocation(argIndex, newLoc);
    }
  }, {
    key: "computeSelfNodes",
    value: function computeSelfNodes() {
      if (arguments.length === 2) {
        var li = arguments[0],
          computeRingSelfNodes = arguments[1];
        return this.computeSelfNodes(li, computeRingSelfNodes, false);
      } else if (arguments.length === 3) {
        var _li = arguments[0],
          _computeRingSelfNodes = arguments[1],
          isDoneIfProperInt = arguments[2];
        var si = new SegmentIntersector(_li, true, false);
        si.setIsDoneIfProperInt(isDoneIfProperInt);
        var esi = this.createEdgeSetIntersector();
        var isRings = this._parentGeom instanceof LinearRing || this._parentGeom instanceof Polygon || this._parentGeom instanceof MultiPolygon;
        var computeAllSegments = _computeRingSelfNodes || !isRings;
        esi.computeIntersections(this._edges, si, computeAllSegments);
        this.addSelfIntersectionNodes(this._argIndex);
        return si;
      }
    }
  }, {
    key: "computeSplitEdges",
    value: function computeSplitEdges(edgelist) {
      for (var i = this._edges.iterator(); i.hasNext();) {
        var e = i.next();
        e.eiList.addSplitEdges(edgelist);
      }
    }
  }, {
    key: "computeEdgeIntersections",
    value: function computeEdgeIntersections(g, li, includeProper) {
      var si = new SegmentIntersector(li, includeProper, true);
      si.setBoundaryNodes(this.getBoundaryNodes(), g.getBoundaryNodes());
      var esi = this.createEdgeSetIntersector();
      esi.computeIntersections(this._edges, g._edges, si);
      return si;
    }
  }, {
    key: "getGeometry",
    value: function getGeometry() {
      return this._parentGeom;
    }
  }, {
    key: "getBoundaryNodeRule",
    value: function getBoundaryNodeRule() {
      return this._boundaryNodeRule;
    }
  }, {
    key: "hasTooFewPoints",
    value: function hasTooFewPoints() {
      return this._hasTooFewPoints;
    }
  }, {
    key: "addPoint",
    value: function addPoint() {
      if (arguments[0] instanceof Point) {
        var p = arguments[0];
        var coord = p.getCoordinate();
        this.insertPoint(this._argIndex, coord, Location.INTERIOR);
      } else if (arguments[0] instanceof Coordinate) {
        var pt = arguments[0];
        this.insertPoint(this._argIndex, pt, Location.INTERIOR);
      }
    }
  }, {
    key: "addPolygon",
    value: function addPolygon(p) {
      this.addPolygonRing(p.getExteriorRing(), Location.EXTERIOR, Location.INTERIOR);
      for (var i = 0; i < p.getNumInteriorRing(); i++) {
        var hole = p.getInteriorRingN(i);
        this.addPolygonRing(hole, Location.INTERIOR, Location.EXTERIOR);
      }
    }
  }, {
    key: "addEdge",
    value: function addEdge(e) {
      this.insertEdge(e);
      var coord = e.getCoordinates();
      this.insertPoint(this._argIndex, coord[0], Location.BOUNDARY);
      this.insertPoint(this._argIndex, coord[coord.length - 1], Location.BOUNDARY);
    }
  }, {
    key: "addLineString",
    value: function addLineString(line) {
      var coord = CoordinateArrays.removeRepeatedPoints(line.getCoordinates());
      if (coord.length < 2) {
        this._hasTooFewPoints = true;
        this._invalidPoint = coord[0];
        return null;
      }
      var e = new Edge(coord, new Label(this._argIndex, Location.INTERIOR));
      this._lineEdgeMap.put(line, e);
      this.insertEdge(e);
      Assert.isTrue(coord.length >= 2, 'found LineString with single point');
      this.insertBoundaryPoint(this._argIndex, coord[0]);
      this.insertBoundaryPoint(this._argIndex, coord[coord.length - 1]);
    }
  }, {
    key: "getInvalidPoint",
    value: function getInvalidPoint() {
      return this._invalidPoint;
    }
  }, {
    key: "getBoundaryPoints",
    value: function getBoundaryPoints() {
      var coll = this.getBoundaryNodes();
      var pts = new Array(coll.size()).fill(null);
      var i = 0;
      for (var it = coll.iterator(); it.hasNext();) {
        var node = it.next();
        pts[i++] = node.getCoordinate().copy();
      }
      return pts;
    }
  }, {
    key: "getBoundaryNodes",
    value: function getBoundaryNodes() {
      if (this._boundaryNodes === null) this._boundaryNodes = this._nodes.getBoundaryNodes(this._argIndex);
      return this._boundaryNodes;
    }
  }, {
    key: "addSelfIntersectionNode",
    value: function addSelfIntersectionNode(argIndex, coord, loc) {
      if (this.isBoundaryNode(argIndex, coord)) return null;
      if (loc === Location.BOUNDARY && this._useBoundaryDeterminationRule) this.insertBoundaryPoint(argIndex, coord);else this.insertPoint(argIndex, coord, loc);
    }
  }, {
    key: "addPolygonRing",
    value: function addPolygonRing(lr, cwLeft, cwRight) {
      if (lr.isEmpty()) return null;
      var coord = CoordinateArrays.removeRepeatedPoints(lr.getCoordinates());
      if (coord.length < 4) {
        this._hasTooFewPoints = true;
        this._invalidPoint = coord[0];
        return null;
      }
      var left = cwLeft;
      var right = cwRight;
      if (Orientation.isCCW(coord)) {
        left = cwRight;
        right = cwLeft;
      }
      var e = new Edge(coord, new Label(this._argIndex, Location.BOUNDARY, left, right));
      this._lineEdgeMap.put(lr, e);
      this.insertEdge(e);
      this.insertPoint(this._argIndex, coord[0], Location.BOUNDARY);
    }
  }, {
    key: "insertPoint",
    value: function insertPoint(argIndex, coord, onLocation) {
      var n = this._nodes.addNode(coord);
      var lbl = n.getLabel();
      if (lbl === null) n._label = new Label(argIndex, onLocation);else lbl.setLocation(argIndex, onLocation);
    }
  }, {
    key: "createEdgeSetIntersector",
    value: function createEdgeSetIntersector() {
      return new SimpleMCSweepLineIntersector();
    }
  }, {
    key: "addSelfIntersectionNodes",
    value: function addSelfIntersectionNodes(argIndex) {
      for (var i = this._edges.iterator(); i.hasNext();) {
        var e = i.next();
        var eLoc = e.getLabel().getLocation(argIndex);
        for (var eiIt = e.eiList.iterator(); eiIt.hasNext();) {
          var ei = eiIt.next();
          this.addSelfIntersectionNode(argIndex, ei.coord, eLoc);
        }
      }
    }
  }, {
    key: "add",
    value: function add() {
      if (arguments.length === 1 && arguments[0] instanceof Geometry) {
        var g = arguments[0];
        if (g.isEmpty()) return null;
        if (g instanceof MultiPolygon) this._useBoundaryDeterminationRule = false;
        if (g instanceof Polygon) this.addPolygon(g);else if (g instanceof LineString) this.addLineString(g);else if (g instanceof Point) this.addPoint(g);else if (g instanceof MultiPoint) this.addCollection(g);else if (g instanceof MultiLineString) this.addCollection(g);else if (g instanceof MultiPolygon) this.addCollection(g);else if (g instanceof GeometryCollection) this.addCollection(g);else throw new UnsupportedOperationException(g.getGeometryType());
      } else {
        return _get(_getPrototypeOf(GeometryGraph.prototype), "add", this).apply(this, arguments);
      }
    }
  }, {
    key: "addCollection",
    value: function addCollection(gc) {
      for (var i = 0; i < gc.getNumGeometries(); i++) {
        var g = gc.getGeometryN(i);
        this.add(g);
      }
    }
  }, {
    key: "locate",
    value: function locate(pt) {
      if (hasInterface(this._parentGeom, Polygonal) && this._parentGeom.getNumGeometries() > 50) {
        if (this._areaPtLocator === null) this._areaPtLocator = new IndexedPointInAreaLocator(this._parentGeom);
        return this._areaPtLocator.locate(pt);
      }
      return this._ptLocator.locate(pt, this._parentGeom);
    }
  }, {
    key: "findEdge",
    value: function findEdge() {
      if (arguments.length === 1 && arguments[0] instanceof LineString) {
        var line = arguments[0];
        return this._lineEdgeMap.get(line);
      } else {
        return _get(_getPrototypeOf(GeometryGraph.prototype), "findEdge", this).apply(this, arguments);
      }
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._parentGeom = null;
      this._lineEdgeMap = new HashMap();
      this._boundaryNodeRule = null;
      this._useBoundaryDeterminationRule = true;
      this._argIndex = null;
      this._boundaryNodes = null;
      this._hasTooFewPoints = false;
      this._invalidPoint = null;
      this._areaPtLocator = null;
      this._ptLocator = new PointLocator();
      if (arguments.length === 2) {
        var argIndex = arguments[0],
          parentGeom = arguments[1];
        GeometryGraph.constructor_.call(this, argIndex, parentGeom, BoundaryNodeRule.OGC_SFS_BOUNDARY_RULE);
      } else if (arguments.length === 3) {
        var _argIndex = arguments[0],
          _parentGeom = arguments[1],
          boundaryNodeRule = arguments[2];
        this._argIndex = _argIndex;
        this._parentGeom = _parentGeom;
        this._boundaryNodeRule = boundaryNodeRule;
        if (_parentGeom !== null) this.add(_parentGeom);
      }
    }
  }, {
    key: "determineBoundary",
    value: function determineBoundary(boundaryNodeRule, boundaryCount) {
      return boundaryNodeRule.isInBoundary(boundaryCount) ? Location.BOUNDARY : Location.INTERIOR;
    }
  }]);
  return GeometryGraph;
}(PlanarGraph);
export { GeometryGraph as default };